import React from "react";
export const PortalContext = React.createContext(undefined);
const PortalProvider = ({ children, portal }) => {
    //const [portal, loading, error] = useAPI('/ajax/portal.php');
    if (!portal) {
        portal = window.NTLF_CONFIG.portal;
    }
    return (React.createElement(PortalContext.Provider, { value: portal }, children));
};
export default PortalProvider;
export const usePortal = () => {
    const context = React.useContext(PortalContext);
    if (!context) {
        throw new Error("usePortal must be used within a PortalProvider");
    }
    console.log("Context is", context);
    return context;
};
